"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "list-module__container___NhFUk",
  "row": "list-module__row___ADDfb",
  "label": "list-module__label___CbrAU",
  "value": "list-module__value___nBdps"
};
function key(listObj) {
  const {
    labelId,
    labelString,
    valueId,
    valueString
  } = listObj;
  return labelId + labelString + valueId + valueString;
}

/**
 * List creates a commonly used, in UserProfile and vehicle metrics popout,
 * vertical list of <label> : <value> rows, such as "Make : Ford".  It is also
 * possible for the value to be a component, such as AuButton.
 * @type {Object}
 */
class List extends _AuComponent.default {
  static propTypes = {
    list: T.arrayOf(T.oneOfType([T.shape({
      className: T.string,
      labelId: T.string,
      labelString: T.string,
      labelClassName: T.string,
      valueId: T.string,
      valueString: T.string,
      valueComponent: T.element,
      valueClassName: T.string
    }), T.bool])).isRequired,
    className: T.string
  };
  renderValue(row) {
    if (row.valueComponent) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.valuecomponent, row.valueClassName)
      }, row.valueComponent);
    } else {
      return /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: row.valueId,
        displayString: row.valueString,
        className: (0, _classnames.default)(styles.value, row.valueClassName)
      });
    }
  }
  renderRows() {
    const {
      list
    } = this.props;
    const rows = [];
    for (let row of list) {
      row && rows.push( /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.row, row.className),
        key: key(row)
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: row.labelId,
        displayString: row.labelString,
        className: (0, _classnames.default)(styles.label, row.labelClassName)
      }), this.renderValue(row)));
    }
    return rows;
  }
  render() {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, this.renderRows());
  }
}
exports.default = List;